<template>
  <div>
    <FormCard
      v-model="empowerment"
      @formSubmit="$emit('formSubmit', $event)"
      @destroyClick="$emit('clickDestroy', $event)">
      <CardForm
        :resource="empowerment"
        :section-title="formTitle"
        resource-name="empowerment">
        <TextInput
          v-model="empowerment.email"
          name="empowerment[user_email]"
          :custom-label="$t('empowerment.email')"
          :disclaimer="$t('empowerment.emailDisclaimer', { tenant: currentTenant.name })"
          prepend="@"
          required />
        <MultipleCheckboxes
          label="Rights"
          :container-style="false"
          @selectAll="selectAll($event, 'selectedTeammateAbilities', 'allRights')">
          <CheckBox
            v-for="right in allRights"
            :key="right.id"
            v-model="selectedTeammateAbilities"
            name="empowerment[teammate_ability_ids][]"
            :label="right.title"
            :submitted-value="right.id" />
        </MultipleCheckboxes>
      </CardForm>
    </FormCard>
    <DestroyDisclaimer v-if="empowerment.id"
                       :title="$t('empowerment.cancel.title')"
                       :button-title="$t('empowerment.cancel.button')"
                       :label-text="$t('empowerment.cancel.text')"
                       @destroyClick="$emit('clickDestroy', $event)">
      <span v-html="$t('empowerment.cancel.body', { tenant: currentTenant.name })" />
    </DestroyDisclaimer>
  </div>
</template>

<script>
import FormCard from "../../../shared/components/UI/FormCard.vue";
import CardForm from "../../../shared/components/UI/CardForm.vue";
import TextInput from "../../../shared/components/UI/TextInput.vue";
import CheckBox from "../../../shared/components/UI/CheckBox.vue";
import MultipleCheckboxes from "../../../shared/components/UI/MultipleCheckboxes.vue";
import DestroyDisclaimer from "../../../shared/components/UI/DestroyDisclaimer.vue";
import MultipleCheckboxMixin from "@shared/Mixins/MultipleCheckboxMixin";

export default {
  name: "EmpowermentForm",

  components: {
    FormCard,
    CardForm,
    TextInput,
    CheckBox,
    MultipleCheckboxes,
    DestroyDisclaimer
  },

  mixins: [MultipleCheckboxMixin],

  props: {
    empowerment: { type: Object, required: true },
    allRights: { type: Array, default: () => [] }
  },

  data: function () {
    return {
      selectedTeammateAbilities: this.empowerment.teammate_ability_ids,
      currentTenant: Dashboard.currentTenant
    };
  },

  computed: {
    submitButtonName () {
      return this.empowerment.id ? this.$t("common.update") : this.$t("common.create");
    },

    formTitle () {
      return this.empowerment.id ? this.$t("common.editModel", { model: this.$t("empowerment.model") }) : this.$t("common.newModel", { model: this.$t("empowerment.model") });
    }
  }
};
</script>
